import StageBoxTariffForm from '@/components/StageBoxTariffForm/StageBoxTariffForm';
import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import {
  ButtonAlign,
  ButtonColor,
  ButtonWidth,
  ShowAddon,
} from '../Button/consts';
import type { RegioStageBoxProps } from './interfaces';
import styles from './RegioStageBox.module.scss';

const RegioStageBox = ({ title, ...props }: RegioStageBoxProps) => {
  const isMobile = useIsMobile(768);

  return (
    <div className={styles.base}>
      <h2 className={styles.title}>{title}</h2>
      <StageBoxTariffForm
        {...props}
        isBoxOnGradient={false}
        submitButtonColor={ButtonColor.Primary}
        submitButtonAlign={ButtonAlign.Center}
        submitButtonAddon={ShowAddon.Plain}
        submitButtonWidth={isMobile ? ButtonWidth.Full : ButtonWidth.Auto}
        className={styles.form}
        classNameFormGroup={styles.formGroup}
      />
    </div>
  );
};

export default RegioStageBox;
